/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" @select="handleSelect" collapse-transition router
           :unique-opened="true"
           :default-active="$route.path" class="el-menu-vertical-demo" background-color="#fff"
           text-color="#333333" active-text-color="#409EFF">
    <div v-if="isShowAds&&isClickClose==0" class="pr ads-box"><img @click="gotoYs()" src="/static/img/ads-img.png" alt=""><span
      class="colse" @click="close()">关闭</span></div>
    <template v-for="menu in allmenu">
      <el-submenu v-if="menu.menus.length" :key="menu.menuid" :index="menu.menuname">
        <template slot="title">
          <i class="iconfont" :class="activeUrl==menu.url?menu.iconActive:menu.icon"></i>
          <span>{{menu.menuname}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.menus" :index="chmenu.url" :key="chmenu.menuid"
                        @click="clickMenu(chmenu)">
            <i class="iconfont" :class="activeUrl==chmenu.url?chmenu.iconActive:chmenu.icon"></i>
            <span>{{chmenu.menuname}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item v-else :index="menu.url" @click="clickMenu(menu)">
        <i class="iconfont" :class="activeUrl==menu.url?menu.iconActive:menu.icon"></i>
        <span slot="title">{{menu.menuname}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
  import {menu} from '../api/userMG'

  export default {
    name: 'leftnav',
    data() {
      return {
        collapsed: false,
        allmenu: [],
        activeUrl: '/dashboard/Dashboard',
        isShowAds: false,
        isClickClose: 0,
        agentType: localStorage.getItem('agent_type')||'2891',
        exclusiveMall: localStorage.getItem('exclusiveMall') || '0'
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.activeUrl = localStorage.getItem('path')
      if (this.agentType == '2890') {
        this.activeUrl = localStorage.getItem('path')
        let res = {
          success: true,
          data1: [
            {
              menuid: 20,
              icon: 'store',
              iconActive: 'store-active',
              menuname: '店铺管理',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 25,
                  menuname: '快递设置管理',
                  hasThird: 'N',
                  url: '/store/storeExpress',
                  menus: null
                },
              ]
            },
            {
              menuid: 44,
              icon: 'afterSale',
              iconActive: 'afterSale-active',
              menuname: '供货管理',
              hasThird: null,
              url: '',
              menus: [
                {
                  menuid: 45,
                  menuname: '供货身份管理',
                  hasThird: 'N',
                  url: '/supply/supplyType',
                  menus: null
                },
                {
                  menuid: 46,
                  menuname: '供货关系管理',
                  hasThird: 'N',
                  url: '/supply/supplyRelationship',
                  menus: null
                },
                {
                  menuid: 48,
                  menuname: '供货商品管理',
                  hasThird: 'N',
                  url: '/supply/supplyGood',
                  menus: null
                },
                {
                  menuid: 49,
                  menuname: '供货订单管理',
                  hasThird: 'N',
                  url: '/supply/supplyOrder',
                  menus: null
                },
                // {
                //   menuid: 52,
                //   menuname: '供货发票管理',
                //   hasThird: 'N',
                //   url: '/supply/supplyInvoice',
                //   menus: null
                // },
                {
                  menuid: 53,
                  menuname: '供货退货管理',
                  hasThird: 'N',
                  url: '/supply/supplyReturn',
                  menus: null
                },
              ]
            },{
              menuid: 160,
              icon: 'sionVer',
              iconActive: 'sionVer-active',
              menuname: '版本更新日志',
              hasThird: null,
              url: '/version/versionAuto',
              menus: []
            },
          ],
          msg: 'success'
        }
        if (localStorage.getItem('custId')) {
          this.allmenu = res.data1
        } else {
          this.allmenu = res.data1.slice(0, -1)
        }
      } else {
        this.activeUrl = localStorage.getItem('path')
        let res = {
          success: true,
          data: [
            {
              menuid: 1,
              icon: 'home',
              iconActive: 'home-active',
              menuname: '首页',
              hasThird: null,
              url: '/dashboard/Dashboard',
              menus: []
            },
            {
              menuid: 10,
              icon: 'good',
              iconActive: 'good-active',
              menuname: '商品管理',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 11,
                  // icon: 'goodInfo',
                  // iconActive: 'goodInfo-active',
                  menuname: '商品基础信息管理',
                  hasThird: 'N',
                  url: '/goods/GoodInfo',
                  menus: null
                },
                {
                  menuid: 12,
                  // icon: 'putonGood',
                  // iconActive: 'putonGood-active',
                  menuname: '商品上架管理',
                  hasThird: 'N',
                  url: '/goods/Goods',
                  menus: null
                },
                {
                  menuid: 13,
                  // icon: 'GoodAttr',
                  // iconActive: 'GoodAttr-active',
                  menuname: '动态属性管理',
                  hasThird: 'N',
                  url: '/goods/GoodAttr',
                  menus: null
                },
                {
                  menuid: 14,
                  // icon: 'labelGood',
                  // iconActive: 'labelGood-active',
                  menuname: '销售标签管理',
                  hasThird: 'N',
                  url: '/goods/GoodLabel',
                  menus: null
                },
                {
                  menuid: 15,
                  // icon: 'AssociationGood',
                  // iconActive: 'AssociationGood-active',
                  menuname: '商品关联管理',
                  hasThird: 'N',
                  url: '/goods/GoodAssociation',
                  menus: null
                },
                {
                  menuid: 16,
                  // icon: 'mendGood',
                  // iconActive: 'mendGood-active',
                  menuname: '页面推荐管理',
                  hasThird: 'N',
                  url: '/goods/Goodmend',
                  menus: null
                }
              ]
            },
            // {
            //   menuid: 17,
            //   icon: 'rule',
            //   iconActive: 'rule-active',
            //   menuname: '入驻商规则',
            //   hasThird: null,
            //   url: null,
            //   menus: [
            //     {
            //       menuid: 18,
            //       // icon: 'InboundRules',
            //       // iconActive: 'InboundRules-active',
            //       menuname: '入驻商规则',
            //       hasThird: 'N',
            //       url: '/rules/rulesInbound',
            //       menus: null
            //     },
            //     {
            //       menuid: 19,
            //       // icon: 'DetailsRules',
            //       // iconActive: 'DetailsRules-active',
            //       menuname: '规范详情',
            //       hasThird: 'N',
            //       url: '/rules/rulesDetails',
            //       menus: null
            //     }
            //   ]
            // },
            {
              menuid: 20,
              icon: 'store',
              iconActive: 'store-active',
              menuname: '店铺管理',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 21,
                  // icon: 'storeMessage',
                  // iconActive: 'storeMessage-active',
                  menuname: '店铺信息管理',
                  hasThird: 'N',
                  url: '/store/storeMessage',
                  menus: null
                },
                {
                  menuid: 22,
                  // icon: 'storeSort',
                  // iconActive: 'storeSort-active',
                  menuname: '店铺分类管理',
                  hasThird: 'N',
                  url: '/store/storeSort',
                  menus: null
                },
                {
                  menuid: 23,
                  menuname: '店铺装饰管理',
                  hasThird: 'N',
                  url: '/store/storeDecoration',
                  menus: null
                },
                {
                  menuid: 24,
                  menuname: '快递运费管理',
                  hasThird: 'N',
                  url: '/store/expressFee',
                  menus: null
                },
                {
                  menuid: 25,
                  menuname: '快递设置管理',
                  hasThird: 'N',
                  url: '/store/storeExpress',
                  menus: null
                },
                {
                  menuid: 26,
                  menuname: '绑定打印机',
                  hasThird: 'N',
                  url: '/store/storePrinter',
                  menus: null
                },
                {
                  menuid: 27,
                  menuname: '专属商城管理',
                  hasThird: 'N',
                  url: '/store/ExclusiveGaining',
                  menus: null
                },
              ]
            },
            {
              menuid: 33,
              icon: 'order',
              iconActive: 'order-active',
              menuname: '订单管理',
              hasThird: null,
              url: '/order/AllOrder',
              menus: []
            },
            {
              menuid: 44,
              icon: 'afterSale',
              iconActive: 'afterSale-active',
              menuname: '供货管理',
              hasThird: null,
              url: '',
              menus: [
                {
                  menuid: 45,
                  menuname: '供货身份管理',
                  hasThird: 'N',
                  url: '/supply/supplyType',
                  menus: null
                },
                {
                  menuid: 46,
                  menuname: '供货关系管理',
                  hasThird: 'N',
                  url: '/supply/supplyRelationship',
                  menus: null
                },
                {
                  menuid: 47,
                  menuname: '需供货商品管理',
                  hasThird: 'N',
                  url: '/supply/quiltSupplyGood',
                  menus: null
                },
                {
                  menuid: 48,
                  menuname: '供货商品管理',
                  hasThird: 'N',
                  url: '/supply/supplyGood',
                  menus: null
                },
                {
                  menuid: 49,
                  menuname: '供货订单管理',
                  hasThird: 'N',
                  url: '/supply/supplyOrder',
                  menus: null
                },
                // {
                //   menuid: 52,
                //   menuname: '供货发票管理',
                //   hasThird: 'N',
                //   url: '/supply/supplyInvoice',
                //   menus: null
                // },
                {
                  menuid: 53,
                  menuname: '供货退货管理',
                  hasThird: 'N',
                  url: '/supply/supplyReturn',
                  menus: null
                },
              ]
            },
            {
              menuid: 150,
              icon: 'supply',
              iconActive: 'afterSale-active',
              menuname: '售后服务',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 151,
                  // icon: 'aftersaleOrder',
                  // iconActive: 'aftersaleOrder-active',
                  menuname: '售后单管理',
                  hasThird: 'N',
                  url: '/aftersale/Aftersale',
                  menus: null
                },
                {
                  menuid: 152,
                  // icon: 'aftersaleAddress',
                  // iconActive: 'aftersaleAddress-active',
                  menuname: '售后地址管理',
                  hasThird: 'N',
                  url: '/aftersale/aftersaleAddress',
                  menus: null
                },
                {
                  menuid: 153,
                  // icon: 'aftersaleService',
                  // iconActive: 'aftersaleService-active',
                  menuname: '售后服务管理',
                  hasThird: 'N',
                  url: '/aftersale/aftersaleService',
                  menus: null
                }
              ]
            },
            {
              menuid: 170,
              icon: 'marketing-manage',
              menuname: '营销管理',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 171,
                  // icon: 'couponRules',
                  // iconActive: 'couponRules-active',
                  menuname: '优惠券规则管理',
                  hasThird: 'N',
                  url: '/Marketing/couponRules',
                  menus: null
                },
                {
                  menuid: 172,
                  // icon: 'couponManage',
                  // iconActive: 'couponManage-active',
                  menuname: '优惠券管理',
                  hasThird: 'N',
                  url: '/Marketing/couponManage',
                  menus: null
                },
                {
                  menuid: 173,
                  // icon: 'gift',
                  // iconActive: 'gift-active',
                  menuname: '商品赠品管理',
                  hasThird: 'N',
                  url: '/Marketing/Gift',
                  menus: null
                },
                {
                  menuid: 174,
                  // icon: 'flashManage',
                  // iconActive: 'flashManage-active',
                  menuname: '秒杀管理',
                  hasThird: 'N',
                  url: '/Marketing/flashManage',
                  menus: null
                },
                {
                  menuid: 175,
                  // icon: 'groupManage',
                  // iconActive: 'groupManage-active',
                  menuname: '拼团管理',
                  hasThird: 'N',
                  url: '/Marketing/groupManage',
                  menus: null
                },
                {
                  menuid: 176,
                  // icon: 'orderFullRedManage',
                  // iconActive: 'orderFullRedManage-active',
                  menuname: '订单满减管理',
                  hasThird: 'N',
                  url: '/Marketing/orderFullRedManage',
                  menus: null
                },
                {
                  menuid: 177,
                  // icon: 'orderFullGiftManage',
                  // iconActive: 'orderFullGiftManage-active',
                  menuname: '订单满赠管理',
                  hasThird: 'N',
                  url: '/Marketing/orderFullGiftManage',
                  menus: null
                },
                {
                  menuid: 178,
                  menuname: '商品议价管理',
                  hasThird: 'N',
                  url: '/Marketing/goodBargaining',
                  menus: null
                }
              ]
            },
            {
              menuid: 128,
              icon: 'money-manage',
              menuname: '财务管理',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 28,
                  menuname: '客户账期管理',
                  hasThird: 'N',
                  url: '/store/storeAccount',
                  menus: null
                },
                {
                  menuid: 129,
                  // icon: 'invoice',
                  // iconActive: 'invoice-active',
                  menuname: '已开发票',
                  hasThird: 'N',
                  url: '/finance/Invoice',
                  menus: null
                },
                {
                  menuid: 130,
                  // icon: 'invoicingApplication',
                  // iconActive: 'invoicingApplication-active',
                  menuname: '开票申请',
                  hasThird: 'N',
                  url: '/finance/InvoicingApplication',
                  menus: null
                },
                {
                  menuid: 131,
                  // icon: 'reconciliation',
                  // iconActive: 'reconciliation-active',
                  menuname: '对账单',
                  hasThird: 'N',
                  url: '/finance/Reconciliation',
                  menus: null
                },
                {
                  menuid: 50,
                  menuname: '供货对账单',
                  hasThird: 'N',
                  url: '/supply/supplyReconciliation',
                  menus: null
                },
                // {
                //   menuid: 51,
                //   menuname: '供货提现',
                //   hasThird: 'N',
                //   url: '/supply/supplyWithdrawal',
                //   menus: null
                // },
                {
                  menuid: 132,
                  // icon: 'serviceInvoicie',
                  // iconActive: 'serviceInvoicie-active',
                  menuname: '服务费开票',
                  hasThird: 'N',
                  url: '/finance/serviceInvoicie',
                  menus: null
                },
                {
                  menuid: 133,
                  // icon: 'orderWithdrawal',
                  // iconActive: 'orderWithdrawal-active',
                  menuname: '订单提现',
                  hasThird: 'N',
                  url: '/finance/orderWithdrawal',
                  menus: null
                },
                {
                  menuid: 134,
                  // icon: 'Agreement',
                  // iconActive: 'Agreement-active',
                  menuname: '入驻协议',
                  hasThird: null,
                  url: '/finance/Agreement',
                  menus: []
                },
              ]
            },
            {
              menuid: 140,
              icon: 'service',
              iconActive: 'service-active',
              menuname: '会员服务管理',
              hasThird: null,
              url: null,
              menus: [
                {
                  menuid: 141,
                  // icon: 'Productconsultation',
                  // iconActive: 'Productconsultation-active',
                  menuname: '商品咨询管理',
                  hasThird: 'N',
                  url: '/service/Productconsultation',
                  menus: null
                },
                {
                  menuid: 142,
                  // icon: 'Reviews',
                  // iconActive: 'Reviews-active',
                  menuname: '商品评价管理',
                  hasThird: 'N',
                  url: '/service/Reviews',
                  menus: null
                },
              ]
            },
            {
              menuid: 159,
              icon: 'system',
              iconActive: 'system-active',
              menuname: '系统消息',
              hasThird: null,
              url: '/system/systemMessages',
              menus: []
            },
            {
              menuid: 160,
              icon: 'sionVer',
              iconActive: 'sionVer-active',
              menuname: '版本更新日志',
              hasThird: null,
              url: '/version/versionAuto',
              menus: []
            },
            {
              menuid: 200,
              icon: 'customer',
              iconActive: 'customer-active',
              menuname: '客服系统',
              hasThird: null,
              url: '/customer/customer',
              menus: []
            },
          ],
          msg: 'success'
        }
        if (localStorage.getItem('custId')) {
          this.allmenu = this.filterExclusiveMall(res.data)
        } else {
          this.allmenu = this.filterExclusiveMall(res.data.slice(0, -1))
        }
      }

      // menu(localStorage.getItem('logintoken'))
      //   .then(res => {
      //     console.log(JSON.stringify(res))
      //     if (res.success) {
      //       this.allmenu = res.data
      //     } else {
      //       this.$message.error(res.msg)
      //       return false
      //     }
      //   })
      //   .catch(err => {
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
      // 监听
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    },
    mounted() {
      if (localStorage.getItem('songbai_system') == 1) {
        this.isShowAds = false
      } else {
        this.isShowAds = true
      }
      this.isClickClose = localStorage.getItem('isClickClose')
    },
    updated() {
      this.activeUrl = localStorage.getItem('path')
    },
    methods: {
      filterExclusiveMall(menuData) {
        if (this.exclusiveMall === '1') {
          return menuData
        }
        // 当 exclusiveMall 为 0 时，过滤掉"专属商城管理"菜单项
        return menuData.map(menu => {
          if (menu.menus && menu.menus.length > 0) {
            return {
              ...menu,
              menus: menu.menus.filter(submenu => submenu.menuid !== 27)
            }
          }
          return menu
        })
      },
      close() {
        this.isShowAds = false
        this.isClickClose = 1
        localStorage.setItem('isClickClose',this.isClickClose)
      },
      gotoYs() {
        window.open('https://www.ussc.com.cn/pages/product/product.html?saleId=663ECC20E4B0449E6F49D9DD&skuId=663F3279E4B04A5921975487')
      },
      handleSelect(key, keyPath) {
        this.activeUrl = key;
        localStorage.setItem('path', key)
      },
      clickMenu(item) {
        this.$store.commit("selectMenu", item);
      },
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .home {
    background: url("/static/img/navIcon/home.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .home-active {
    background: url("/static/img/navIcon/home-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .good {
    background: url("/static/img/navIcon/good.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .good-active {
    background: url("/static/img/navIcon/good-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .goodInfo {
    background: url("/static/img/navIcon/goodInfo.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .goodInfo-active {
    background: url("/static/img/navIcon/goodInfo-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Goodlabel {
    background: url("/static/img/navIcon/Goodlabel.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .putonGood {
    background: url("/static/img/navIcon/putonGood.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .putonGood-active {
    background: url("/static/img/navIcon/putonGood-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .labelGood {
    background: url("/static/img/navIcon/labelGood.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .labelGood-active {
    background: url("/static/img/navIcon/labelGood-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .AssociationGood {
    background: url("/static/img/navIcon/AssociationGood.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .AssociationGood-active {
    background: url("/static/img/navIcon/AssociationGood-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .mendGood {
    background: url("/static/img/navIcon/mendGood.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .mendGood-active {
    background: url("/static/img/navIcon/mendGood-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .GoodAttr {
    background: url("/static/img/navIcon/GoodAttr.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .GoodAttr-active {
    background: url("/static/img/navIcon/GoodAttr-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .goodClassify {
    background: url("/static/img/navIcon/goodClassify.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .goodClassify-active {
    background: url("/static/img/navIcon/goodClassify-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .order {
    background: url("/static/img/navIcon/order.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .order-active {
    background: url("/static/img/navIcon/order-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .afterSale {
    background: url("/static/img/navIcon/afterSale.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .afterSale-active {
    background: url("/static/img/navIcon/afterSale-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .aftersaleOrder {
    background: url("/static/img/navIcon/aftersaleOrder.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .aftersaleOrder-active {
    background: url("/static/img/navIcon/aftersaleOrder-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .aftersaleAddress {
    background: url("/static/img/navIcon/aftersaleAddress.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .aftersaleAddress-active {
    background: url("/static/img/navIcon/aftersaleAddress-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .aftersaleService {
    background: url("/static/img/navIcon/aftersaleService.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .aftersaleService-active {
    background: url("/static/img/navIcon/aftersaleService-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .money-manage {
    background: url("/static/img/money-manage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .invoice {
    background: url("/static/img/navIcon/invoice.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .invoice-active {
    background: url("/static/img/navIcon/invoice-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .reconciliation {
    background: url("/static/img/navIcon/reconciliation.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .reconciliation-active {
    background: url("/static/img/navIcon/reconciliation-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .invoicingApplication {
    background: url("/static/img/navIcon/invoicingApplication.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .invoicingApplication-active {
    background: url("/static/img/navIcon/invoicingApplication-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .marketing-manage {
    background: url("/static/img/navIcon/marketing-manage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .couponRules {
    background: url("/static/img/navIcon/couponRules.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .couponRules-active {
    background: url("/static/img/navIcon/couponRules-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .couponManage {
    background: url("/static/img/navIcon/couponManage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .couponManage-active {
    background: url("/static/img/navIcon/couponManage-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .gift {
    background: url("/static/img/navIcon/gift.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .gift-active {
    background: url("/static/img/navIcon/gift-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .flashManage {
    background: url("/static/img/navIcon/flashManage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .flashManage-active {
    background: url("/static/img/navIcon/flashManage-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .groupManage {
    background: url("/static/img/navIcon/groupManage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .groupManage-active {
    background: url("/static/img/navIcon/groupManage-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .orderFullRedManage {
    background: url("/static/img/navIcon/orderFullRedManage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .orderFullRedManage-active {
    background: url("/static/img/navIcon/orderFullRedManage-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .orderFullGiftManage {
    background: url("/static/img/navIcon/orderFullGiftManage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .orderFullGiftManage-active {
    background: url("/static/img/navIcon/orderFullGiftManage-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .customer {
    background: url("/static/img/navIcon/customer.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .customer-active {
    background: url("/static/img/navIcon/customer-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Agreement {
    background: url("/static/img/navIcon/Agreement.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Agreement-active {
    background: url("/static/img/navIcon/Agreement-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .system {
    background: url("/static/img/navIcon/system.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .system-active {
    background: url("/static/img/navIcon/system-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .sionVer {
    background: url("/static/img/navIcon/version.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .sionVer-active {
    background: url("/static/img/navIcon/version-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .store {
    background: url("/static/img/navIcon/store.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .store-active {
    background: url("/static/img/navIcon/store-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .storeMessage {
    background: url("/static/img/navIcon/storeMessage.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .storeMessage-active {
    background: url("/static/img/navIcon/storeMessage-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .storeSort {
    background: url("/static/img/navIcon/storeSort.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .storeSort-active {
    background: url("/static/img/navIcon/storeSort-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .storeDecoration {
    background: url("/static/img/navIcon/storeDecoration.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .storeDecoration-active {
    background: url("/static/img/navIcon/storeDecoration-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .serviceInvoicie {
    background: url("/static/img/navIcon/serviceInvoicie.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .serviceInvoicie-active {
    background: url("/static/img/navIcon/serviceInvoicie-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .orderWithdrawal {
    background: url("/static/img/navIcon/orderWithdrawal.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .orderWithdrawal-active {
    background: url("/static/img/navIcon/orderWithdrawal-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .service {
    background: url("/static/img/navIcon/service.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .service-active {
    background: url("/static/img/navIcon/service-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Productconsultation {
    background: url("/static/img/navIcon/Productconsultation.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Productconsultation-active {
    background: url("/static/img/navIcon/Productconsultation-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Reviews {
    background: url("/static/img/navIcon/Reviews.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .Reviews-active {
    background: url("/static/img/navIcon/Reviews-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .supply {
    background: url("/static/img/navIcon/supply.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .el-menu::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .el-menu {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
  }

  .logoimg {
    height: 40px;
  }

  .text-active {
    color: #409EFF;
  }

  .rule {
    background: url("/static/img/navIcon/rules.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .rule-active {
    background: url("/static/img/navIcon/rules-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .InboundRules {
    background: url("/static/img/navIcon/InboundRules.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .InboundRules-active {
    background: url("/static/img/navIcon/InboundRules-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .DetailsRules {
    background: url("/static/img/navIcon/DetailsRules.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .DetailsRules-active {
    background: url("/static/img/navIcon/DetailsRules-active.svg");
    display: inline-block;
    width: 22px;
    height: 22px;
  }

  .asideshow {
    border: none;
  }

  .asideshow::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .asideshow {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .ads-box img {
    width: 100%;
    cursor: pointer;
  }

  .pr {
    position: relative;
  }

  .colse {
    position: absolute;
    top: 2px;
    right: 2px;
    font-size: 12px;
    padding: 2px 5px;
    color: #fff;
    border-radius: 2px;
    background: rgba(12, 25, 61, 0.4);
    cursor: pointer;

  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue